/** 通用 */
export default {
    add: "add", // 新增
    operate: "operate", // 操作
    update: "update", // 修改
    delete: "delete", // 删除
    search: "search", // 搜索
    refresh: "refresh", // 重置 刷新
    export: "export", // 导出
    systemStatus: "system status", // 系统状态
    systemStatusPlaceholder: "system status", // 请选择系统状态
    remark: "remark", // 备注
    numericalOrder: "numerical order", // 顺序号
    welcome: "welcome", // 欢迎您
    goBack: "go back", // 返回
}